const KEY = "cs-exchange-flow";

export function loadFlow() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

export function saveFlow(partial) {
  const next = { ...loadFlow(), ...partial };
  sessionStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function clearFlow() {
  sessionStorage.removeItem(KEY);
}

export function normalizeOrderName(value) {
  return String(value || "").trim().replace(/^#/, "").trim();
}

export const EMAIL_PATTERN =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
